import { definePanel } from '@/app/definePanel';
import { MotionIcon } from '@/components/occurra/icons/MotionIcon';

export default definePanel({
    id: 'motion_list',
    title: 'Motion',
    description: 'When and where a camera saw motion, event or no event.',
    icon: MotionIcon,
    // A browse list like Objects and Events, not an elastic surface: it keeps
    // the width it was dragged to and the preview beside it does the filling.
    width: { min: 320, default: 320, max: Infinity, fill: false },
    modes: ['view'], // view-only — switching to settings will auto-close it
    themes: 'any',
    // Shares the "primary list" slot with events_list / objects_list /
    // video_search: it sits in its own COMPATIBILITY_GROUPS entry (with the
    // cameras tree + preview + notifications) but NOT with them, so opening
    // Motion closes whichever of those was up. See src/app/exclusions.ts.
    // Just right of Objects (4) / Events (4.3) — the three browse lists read
    // left-to-right in the nav, ahead of Video search.
    order: 4.35,
    // Hidden from the rail. The chat and the links of other panels still open it.
    hasNavButton: false,
    // Scope the list to the camera selected elsewhere in the shell (cameras
    // panel, camera_view). Motion is per-camera, so the panel prompts for a
    // camera when this is empty ("All cameras").
    urlSyncedProps: ['cameraId'],
});
